export default __webpack_public_path__ + "static/media/Co2Reduction.cb48176b.svg";